import "./PolitiqueConfidentialite.css";
import React from "react";

function template() {
  return (
    <div className="politique-confidentialite p-5">
      <h1>Politique de confidentialité</h1>
      Nous respectons la confidentialité de nos utilisateurs et nous nous
      engageons à protéger leurs informations personnelles. Cette politique de
      confidentialité décrit les informations que nous collectons, comment nous
      les utilisons et comment nous les protégeons.
      <h2>Informations collectées :</h2>
      Lorsque vous vous connectez à notre application avec Facebook, nous avons
      accès à certaines informations de votre profil Facebook, telles que votre
      nom, votre adresse e-mail et votre photo de profil.
      <h2>Comment nous utilisons vos informations :</h2>
      Nous utilisons les informations collectées pour lier votre compte à notre
      application et pour vous identifier lors de chaque connexion à
      l'application. Nous ne partagerons pas, ni vendrons vos informations
      personnelles à des tiers sans votre consentement explicite.
      <h2>Protection de vos informations :</h2>
      Nous prenons des mesures de sécurité pour protéger vos informations
      personnelles contre la perte, l'utilisation abusive, l'accès non autorisé,
      la divulgation, la modification ou la destruction. Nous utilisons
      également des mesures de sécurité pour empêcher l'accès non autorisé à vos
      informations personnelles par des tiers.
      <h2>Modifications à cette politique de confidentialité :</h2>
      Nous nous réservons le droit de modifier cette politique de
      confidentialité à tout moment en publiant les nouvelles politiques sur
      cette page. Il est donc important de la consulter régulièrement pour
      rester informé des changements. Si vous avez des questions sur cette
      politique de confidentialité, n'hésitez pas à nous contacter
    </div>
  );
}

export default template;
